import AssistantPanelAskButton from "components/AssistantPanel/AskButton";
import { buildStackOverviewPrompt } from "components/AssistantPanel/prompts";
import Box from "ds/components/Box";
import Tooltip from "ds/components/Tooltip";
import Typography from "ds/components/Typography";
import useTypedContext from "hooks/useTypedContext";
import { StackContext } from "views/Stack/Context";

const StackHeaderAskButton = () => {
  const { stack } = useTypedContext(StackContext);

  return (
    <Tooltip
      widthMode="maxWidthSm"
      on={(props) => (
        <AssistantPanelAskButton
          {...props}
          entryPoint="stack_overview"
          prompt={buildStackOverviewPrompt({ stackId: stack.id })}
          id="stack-view--ask-infra-assistant"
        />
      )}
    >
      <Box direction="column" gap="small">
        <Typography tag="p">Ask Infra Assistant</Typography>
        <Typography tag="p">
          Get a <b>quick summary</b> of <b>this stack</b> — its state, recent runs and what needs
          attention.
        </Typography>
      </Box>
    </Tooltip>
  );
};

export default StackHeaderAskButton;
